import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { AtomicLoadingScreen } from '@/components/ui/atomic-loader';

interface RoleBasedNavigationProps {
  children: React.ReactNode;
  allowedRoles?: ('admin' | 'cliente' | 'analista' | 'vendedor' | 'suporte')[];
  redirectTo?: string;
}

export const RoleBasedNavigation: React.FC<RoleBasedNavigationProps> = ({
  children,
  allowedRoles = ['admin', 'cliente', 'analista'],
  redirectTo = '/'
}) => {
  const { user, isLoading } = useAuth();

  console.log('🔍 [RoleBasedNavigation] Verificando acesso:', { isLoading, user, allowedRoles });

  // Se está carregando, mostrar loading apenas se não há usuário no localStorage
  if (isLoading) {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      console.log('⏳ [RoleBasedNavigation] Carregando com usuário salvo, permitindo acesso temporário...');
      return <>{children}</>;
    }
    console.log('⏳ [RoleBasedNavigation] Carregando sem usuário salvo...');
    return (
      <AtomicLoadingScreen
        message="Verificando autenticação..."
        className="h-screen"
      />
    );
  }

  if (!user) {
    console.log('❌ [RoleBasedNavigation] Usuário não encontrado, redirecionando para /login');
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    console.log('❌ [RoleBasedNavigation] Role não permitido:', user.role, 'Permitidos:', allowedRoles);
    return <Navigate to={redirectTo} replace />;
  }

  console.log('✅ [RoleBasedNavigation] Acesso permitido para:', user.role);
  return <>{children}</>;
};

export const AdminOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <RoleBasedNavigation allowedRoles={['admin']}>
    {children}
  </RoleBasedNavigation>
);

export const ClientOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <RoleBasedNavigation allowedRoles={['cliente']}>
    {children}
  </RoleBasedNavigation>
);

export default RoleBasedNavigation; 